import miniclipLogo from '@src/asset/media/miniclip.png';
import website from '@src/constants/website';

// 原始资源由 ODC_Web_Static 仓库归档维护并上传 CDN
export const ABOUT_KV_VIDEO = `${website.staticBaseUrl}/web/official/about-us/kv.mp4`;
export const ABOUT_KV_VIDEO_WEBM = `${website.staticBaseUrl}/web/official/about-us/kv.webm`;
export const ABOUT_KV_POSTER = `${website.staticBaseUrl}/web/official/about-us/kv.png`;
export const ABOUT_KV_POSTER_WEBP = `${website.staticBaseUrl}/web/official/about-us/kv.webp`;

/**
 * webp 编码能力检测（同步，模块加载时执行一次）：
 * 不支持时 toDataURL('image/webp') 会回退输出 data:image/png。
 * <video poster> 不支持多图回退，不支持 webp 的浏览器需落到 png 封面。
 */
const isWebpSupported = (() => {
  try {
    return document.createElement('canvas').toDataURL('image/webp').startsWith('data:image/webp');
  } catch {
    return false;
  }
})();

export const ABOUT_KV_POSTER_BEST = isWebpSupported ? ABOUT_KV_POSTER_WEBP : ABOUT_KV_POSTER;
export const MINICLIP_LOGO = miniclipLogo;

export const WHO_WE_ARE_TEXT =
  'AdSurge is a global ad platform. We help developers acquire users and monetise at scale.';

export const OUR_ORIGIN_TEXT =
  'AdSurge is proven and built by Miniclip, one of the world\'s biggest developers and publishers of mobile games. Miniclip\'s games reach 400 million players a month, 80 million of them daily, with over 10 billion downloads.';

export const OUR_MISSION_TEXT =
  'Our mission is to drive profitable growth through client centricity, AI innovation and global partnerships.';

export interface IOriginStat {
  value: string;
  label: string;
}

export const originStats: IOriginStat[] = [
  { value: '400M+', label: 'Monthly Players' },
  { value: '80M+', label: 'Daily Players' },
  { value: '12B+', label: 'Lifetime Downloads' },
  { value: '190+', label: 'Countries and Regions' },
];
